import { useReduxSelector } from '@/store/hooks'

import { IconAdvancedRoot } from '../IconAdvancedRoot/IconAdvancedRoot'

type Props = {
  countBounce?: boolean
}

export const IconAdvancedClipboard = ({ countBounce }: Props) => {
  const cardsLength = useReduxSelector((s) => s.clipboard.cards.length)

  return <IconAdvancedRoot count={cardsLength} countBounce={countBounce} variant='clipboard' />
}
